import { render } from "./SaletypeReport.vue?vue&type=template&id=72f75002"
import script from "./SaletypeReport.vue?vue&type=script&lang=js"
export * from "./SaletypeReport.vue?vue&type=script&lang=js"

import "./SaletypeReport.vue?vue&type=style&index=0&id=72f75002&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__